var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCart = function SvgCart(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.987 7.93564L16.8419 14.0807C16.5947 14.3279 16.1939 14.3279 15.9467 14.0807L9.80164 7.93564C9.5544 7.68839 9.5544 7.28762 9.80164 7.04046L15.9467 0.895334C16.1939 0.64817 16.5947 0.64817 16.8419 0.895334L22.987 7.04046C23.2342 7.28762 23.2342 7.68839 22.987 7.93564Z",
    fill: "#20C997"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0895 7.93311L16.7589 9.3175C16.4203 9.45818 16.0322 9.29685 15.892 8.95716L15.0263 6.85973C14.886 6.52004 15.0468 6.13054 15.3853 5.98985L18.7159 4.60547L20.0895 7.93311Z",
    fill: "#FAB005"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7159 3.93073L26.3853 5.31511L25.0117 1.98747L28.3423 0.603082C28.6809 0.462397 29.069 0.623731 29.2092 0.963424L30.0749 3.06077C30.2152 3.40054 30.0544 3.79004 29.7159 3.93073Z",
    fill: "#FAB005"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.62 12.0096L21.8135 15.6701C21.7155 15.7108 21.6033 15.6642 21.5627 15.5659L17.2842 5.20044L26.4453 1.39258L30.7239 11.758C30.7645 11.8562 30.7179 11.9688 30.62 12.0096Z",
    fill: "#FFD43B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.194 3.23486L20.1733 4.90613C19.8795 5.02821 19.5428 4.88824 19.4211 4.59339L19.2227 4.11286C19.101 3.81801 19.2405 3.48005 19.5342 3.35797L23.555 1.6867C23.8487 1.56461 24.1856 1.70459 24.3073 1.99943L24.5056 2.47989C24.6273 2.77474 24.4878 3.11269 24.194 3.23486Z",
    fill: "#FAB005"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5232 29.3986C18.5232 30.5303 17.6057 31.4477 16.474 31.4477C15.3423 31.4477 14.4248 30.5303 14.4248 29.3986C14.4248 28.2668 15.3423 27.3494 16.474 27.3494C17.6057 27.3494 18.5232 28.2668 18.5232 29.3986Z",
    fill: "#F06595"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1921 29.3986C27.1921 30.5303 26.2746 31.4477 25.1429 31.4477C24.0112 31.4477 23.0938 30.5303 23.0938 29.3986C23.0938 28.2668 24.0112 27.3494 25.1429 27.3494C26.2746 27.3494 27.1921 28.2668 27.1921 29.3986Z",
    fill: "#F06595"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6043 19.7831H12.7947C12.1995 19.7831 11.6804 19.3765 11.5347 18.7963L9.1837 9.42933C8.97657 8.60406 9.59708 7.80322 10.4436 7.80322H30.6999C31.5326 7.80322 32.1504 8.57963 31.9677 9.39639L29.872 18.7634C29.7386 19.3595 29.212 19.7831 28.6043 19.7831Z",
    fill: "#8246FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.06 25.2608H14.5877C12.6416 25.2608 10.9506 23.9431 10.4753 22.0564L6.82411 7.55973C6.70171 7.07392 6.26626 6.73462 5.76523 6.73462H1.57441C0.704842 6.73462 0 6.02993 0 5.16068C0 4.29135 0.704842 3.58667 1.57441 3.58667H5.76523C7.71133 3.58667 9.40231 4.90438 9.87764 6.79105L13.5288 21.2876C13.6512 21.7735 14.0867 22.1128 14.5877 22.1128H28.06C28.9296 22.1128 29.6344 22.8175 29.6344 23.6868C29.6344 24.5561 28.9296 25.2608 28.06 25.2608Z",
    fill: "#F06595"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cart.46d3b2da316758de3ef16718c0fda0f5.svg";